import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { settings } from '../../../settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VehicleService {
  api = settings.API_URL;
  fuelTypes: any = [];
  vehicleTypes: any = [];
  selectedVehicleDetails: any = null;
  constructor(private http: HttpClient) {}

  getVehiclesService(sessionHash: any, permitId: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    let apiUrl: any;
    if (permitId) {
      apiUrl =
        this.api +
        `/api/vehicles?sessionHash=${sessionHash}&permitId=${permitId}`;
    } else {
      apiUrl = this.api + `/api/vehicles?sessionHash=${sessionHash}`;
    }
    return this.http.get(apiUrl, { headers });
  }

  addVehiclesService(sessionHash: string, params: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: 'text/plain',
      'Content-Type': 'application/json-patch+json',
    });

    return this.http.post(
      `${this.api}/api/vehicles?sessionHash=${sessionHash}`,
      params.params,
      { headers, responseType: 'text' },
    );
  }

  editVehiclesService(sessionHash: string, params: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
    });
    return this.http.put(
      this.api + `/api/vehicles?sessionHash=${sessionHash}`,
      params.params,
      { headers, responseType: 'text' },
    );
  }

  getVehicleTypeService(params: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    return this.http.get(
      this.api +
        `/api/dropDownCodes?sessionHash=${params.sessionHash}&dropdownCodeType=${params.type}`,
      { headers },
    );
  }

  getVehicleMakes(params: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    return this.http.get(
      this.api + `/api/vehicleMakes?sessionHash=${params.sessionHash}`,
      {
        headers,
      },
    );
  }

  getVehicleModels(params: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    return this.http.get(
      this.api +
        `/api/vehicleModels?sessionHash=${params.sessionHash}&vehicleMakeId=${params.id}`,
      {
        headers,
      },
    );
  }

  getVehicleWithId(params: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    return this.http.get(
      this.api + `/api/vehicles/${params.id}?sessionHash=${params.sessionHash}`,
      { headers, responseType: 'text' },
    );
  }

  editStateRegistrationDateService(
    sessionHash: string,
    params: any,
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
    });
    return this.http.put(
      this.api + `/api/vehicles/stateRegistration?sessionHash=${sessionHash}`,
      params.params,
      { headers, responseType: 'text' },
    );
  }

  deleteVehicleService(sessionHash: string, params: any) {
    return this.http.put(
      this.api + `/api/vehicles/terminate?sessionHash=${sessionHash}`,
      params,
      { responseType: 'text' },
    );
  }

  getTransportationTypeService(params: any): Observable<any> {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    return this.http.get(
      this.api +
        `/api/transportationProviders?sessionHash=${params.sessionHash}`,
      { headers },
    );
  }

  submitVehicleForReviewService(
    sessionHash: string,
    params: any,
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
    });
    return this.http.put(
      this.api +
        `/api/vehicles/submitForReview?sessionHash=${sessionHash}&vehicleId=${params.vehicleId}`,
      params,
      { headers, responseType: 'text' },
    );
  }
}
